import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SelectUI from '../../../widgets/input/SelectUI'
import { Link } from 'react-router-dom'
import SearchUI from '../../../widgets/input/SearchUI'

const Compliance2PageUI = ({
  context, errorList, complianceList, onRefreshClick, onPreviousClick, onNextClick,
  selectedFilter, onFilterChange, selectedStatus, onStatusChange, onSearchFilterChange, searchFilter, onDownloadComplianceReport,
  penaltyList
}) => {
  const filterOptions = [
    { value: 'all', label: 'All' },
    { value: 'financial', label: 'Financial' },
    { value: 'others', label: 'Others' },
  ]
  return (
    <SuperUserHomePageUI
      context={context} className='pg_su_disb_brkp'
      topnav='compliance' page='compliances'
      centered={!complianceList || !errorList}
    >
      {
        (!complianceList || !errorList) &&
        <SpinnerComponentUI />
      }

      {errorList && errorList.length > 0 && <GenericErrorUI error={errorList[0]} />}

      {
        complianceList &&
        <div>
          <LRTableActionsUI
            location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <IconButtonUI icon='icon-download' onClick={onDownloadComplianceReport} label='Download Report' />
                <span className='g_m_left_100 g_large'><b>Compliance Report</b></span>
              </span>
            }
            right={
              <span className='g_text_right'>
                <div className='g_flex_v'>
                  <div className='g_flex_h g_flex_right'>
                    <Link to='#' onClick={onPreviousClick}>Previous</Link>
                    <span className='g_m_left_100' />
                    <Link to='#' onClick={onNextClick}>Next</Link>
                  </div>
                  <div className='g_flex_h g_m_top_20'>
                    <div className='g_flex_v' >
                      <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
                      <span className='g_muted g_small'>
                        Search by account
                      </span>
                    </div>
                    <div className='g_flex_v g_m_left_50' >
                      <SelectUI
                        selectedKey={selectedStatus}
                        optionList={[
                          { label: 'All', value: 'all' },
                          { label: 'Not Complied', value: 'not_complied' },
                          { label: 'Complied', value: 'complied' },
                        ]}
                        onChange={onStatusChange}
                        placeholder="Compliance Status"
                      />
                      <span className='g_muted g_small'>
                        Filter by status
                      </span>
                    </div>
                    <div className='g_flex_v g_m_left_50' >
                      <SelectUI
                        selectedKey={selectedFilter}
                        optionList={filterOptions}
                        onChange={onFilterChange}
                        placeholder='Select Filter'
                      />
                      <span className='g_muted g_small'>
                        Filter by compliance type
                      </span>
                    </div>
                  </div>
                </div>
              </span>
            }
          />
          {
            complianceList.length > 0 && complianceList.map((account, i) =>
              <ComplianceTableUI key={i} account={account} penaltyList={penaltyList} />
            )
          }

          {
            complianceList.length === 0 &&
            <EmptyListUI
              context={context}
              createEnabled={false}
              createDisabledMessageLabel='No Non-Compliances'
            />
          }
        </div>
      }
    </SuperUserHomePageUI>
  )
}

const ComplianceTableUI = ({ account, penaltyList }) => (
  <CardUI className='g_m_bottom_100' noUnderline={true}
    title={
      <span className={`g_flex_h g_flex_left ${account.loanComplianceList.length === 1 ? (account.loanComplianceList[0].complied ? 'g_success' : 'g_error') :
        account.loanComplianceList.every(loan => loan.complied === true) ? 'g_success' :
          account.loanComplianceList.some(loan => loan.complied === false) ? 'g_info' :
            account.loanComplianceList.every(loan => loan.complied === false) ? 'g_error' : ''}`}>
        {account.accountName}
      </span>
    }>
    {
      penaltyList && penaltyList.filter(p => p.accountId === account.accountId).length > 0 &&
      <>
        <div className="g_flex_h g_flex_right">
          <strong>Monitoring Remarks</strong>
        </div>
        {
          penaltyList.filter(p => p.accountId === account.accountId)[0].monitoringRemarksList.length > 0
            ? penaltyList.filter(p => p.accountId === account.accountId)[0].monitoringRemarksList.map((rem, i) =>
              <div key={i} className="g_flex_h g_flex_right">
                {rem.remarks}
              </div>
            )
            : <div className="g_flex_h g_flex_right">No Remarks</div>
        }
      </>
    }
    {
      account.loanComplianceList.map((loan, i) =>
        <CardUI key={i} className='g_m_bottom_50'
          title={
            <div className='g_flex_h'>
              <Link to={`/su/loans/${loan.loanId}/compliance`}>
                {loan.loanReferenceNumber}
              </Link>
              <div className=''>
                {loan.penalChargeF5 && `Penal Charge: ₹ ${loan.penalChargeF5}`}
              </div>
            </div>
          }
        >
          <table className='g_row'>
            <thead>
              <tr>
                <th></th>
                <th>Compliance Title</th>
                <th>Clauses</th>
                <th>Remarks</th>
                {/* <th>Penalty</th> */}
              </tr>
            </thead>
            <tbody>
              {
                loan.complianceCodeList.map((compliance, k) => (
                  <tr className='g_text_top' key={k}>
                    <td>{k + 1}.</td>
                    <td>{compliance.complianceTitle}</td>
                    <td>
                      {
                        compliance.clauseList
                          .filter(clause => clause.status === 'not_complied')
                          .map((clause, l) => (
                            <span key={l} className='g_flex_v'>
                              {clause.clause}
                            </span>
                          ))
                      }
                    </td>
                    <td>
                      {
                        compliance.clauseList
                          .filter(clause => clause.status === 'not_complied')
                          .map((clause, l) => (
                            <span key={l} className='g_flex_v'>
                              {clause.remarks !== null ? clause.remarks : clause.penaltyStatus === 'waived' ? 'Penal charges waived' : ''}
                            </span>
                          ))
                      }
                    </td>
                    {/* <td>
            {
              compliance.clauseList
                .filter(clause => clause.status === 'not_complied')
                .map((clause, l) => (
                  <span key={l} className='g_flex_v'>
                    {clause.penaltyStatus === 'not_waived' ? clause.penalCharge : 'No penalty'}
                  </span>
                ))
            }
          </td> */}
                  </tr>
                ))
              }
            </tbody>
          </table>

        </CardUI>
      )
    }
  </CardUI >
)
export default Compliance2PageUI
